// «الإعدادات» menu rows in board order (settings__* boards): النشاط ·
// الفروع والصناديق · العملة وسعر الصرف · الترقيم والطباعة · شجرة الحسابات ·
// سجل التدقيق · الاشتراك. «سياسة الحجز»، «ساعات العمل» and «التوثيق» have
// no ERP board/route yet → absent (rule 6, no «قريباً»).
//
// Role gates mirror the server (erp-core docs/API.md, bff-business):
//   النشاط / الاشتراك / الفروع / الترقيم والطباعة — owner (HANDOFF §3/§9:
//                             settings are the owner's; the print/numbering
//                             GETs are manager+ only so documents can print)
//   العملة وسعر الصرف        — manager+ read-only (13 §23 gives the manager a
//                             part in the daily rate; the approval PUT is owner)
//   سجل التدقيق              — manager+ (§9: all events). Staff's «own events»
//                             view has no placement yet: the module is
//                             manager+ (index.tsx), so the row is too.
//   شجرة الحسابات           — owner; screen built in ./coa by the accounts agent

import type { MenuItem } from '@/app/module-types';

export const SETTINGS_MENU: MenuItem[] = [
  { key: 'business', label: 'النشاط', to: '/settings/business', minRole: 'owner' },
  { key: 'branches', label: 'الفروع والصناديق', to: '/settings/branches', minRole: 'manager', flag: 'erp.branches' },
  { key: 'currency', label: 'العملة وسعر الصرف', to: '/settings/currency', minRole: 'manager' },
  { key: 'print', label: 'الترقيم والطباعة', to: '/settings/print', minRole: 'owner' },
  { key: 'coa', label: 'شجرة الحسابات', to: '/settings/coa', minRole: 'owner', flag: 'erp.accounts' },
  { key: 'audit', label: 'سجل التدقيق', to: '/settings/audit', minRole: 'manager' },
  { key: 'subscription', label: 'الاشتراك', to: '/settings/subscription', minRole: 'owner', modes: ['online'] },
  // Phase 0 feature control (build plan; no board): the owner's switches within
  // what the platform allows. No flag — it exists whenever the ERP exists.
  // Online only: the switches live on bff-business (platform); a node's
  // localbook has no /v1/business/features and its flags ride on the licence.
  { key: 'features', label: 'الميزات', to: '/settings/features', minRole: 'owner', modes: ['online'] },
  // Board 34 erp/today--dark: the person's light/dark/system choice. Every
  // settings reader; absent while the platform flag ui.dark-mode is off.
  { key: 'appearance', label: 'المظهر', to: '/settings/appearance', minRole: 'staff', flag: 'ui.dark-mode' },
];
